import React from "react";
import { useTranslation } from "react-i18next";
import { View, Text } from "react-native";

import WaitlistImage from "@/assets/waitlist.svg";

export default function Waitlist() {
  const { t } = useTranslation();
  return (
    <View className="bg-white1 w-full rounded-lg shadow">
      <View className="w-full p-2 bg-purple3 rounded-tl-lg rounded-tr-lg">
        <Text className="text-white1 text-xl font-light">
          {t("home/userpanel:sections.updateapplication.title")}
        </Text>
      </View>
      <View className="w-full items-center p-4">
        <Text className="text-xl font-light text-center">
          {t("home/userpanel:sections.updateapplication.waitlist")}
        </Text>
        <WaitlistImage width={250} height={250} />
      </View>
    </View>
  );
}
